<template>
    <div>
        <ui-select
            :options="templates"
            v-model="selectedTemplate"
            :loading="isLoading"
            :keys="{label: 'title', id: 'id'}"
            @change="templateChanged"
            :disabled="disabled"
            placeholder="Select job type"
        ></ui-select>
        <ui-select
            v-if="optionsAreAvailable"
            :options="availableOptions"
            v-model="selectedTemplateOption"
            :loading="isLoading"
            :keys="{label: 'title', id: 'id'}"
            @change="optionChanged"
            :disabled="disabled"
            placeholder="Select job type"
            :invalid="isSelectedTemplateOptionEmpty"
        ></ui-select>
    </div>
</template>

<script>
import {TaskResource, TaskTemplateContexts} from "../../../classes/Api/Task";
import {cloneDeep, isEmpty} from "lodash";

export default {
    props: {
        value: {},
        disabled: {
            type: Boolean,
            default: false
        },
        filterCallback: {
            type: Function
        }
    },
    data() {
        return {
            isLoading: true,
            templates: [],
            selectedTemplate: {},
            selectedTemplateOption: {}
        }
    },
    mounted() {
        this.loadTemplates()

        this.updateInternalValues(this.value)
    },
    watch: {
        value: {
            handler(n, o) {
                if (n !== o) {
                    this.updateInternalValues(n)
                }
            },
            deep: true
        }
    },
    methods: {
        setTemplate(v) {
            this.updateInternalValues(v)

            this.updated()
        },
        updateInternalValues(v) {
            this.selectedTemplate = {}
            this.selectedTemplateOption = {}

            if (v) {
                if (v.type === 'task.template.option') {
                    for (let i in this.templates) {
                        if (this.templates[i].options) {
                            this.selectedTemplateOption = this.templates[i].options.find(
                                i => i.id === v.id
                            )

                            if (this.selectedTemplateOption) {
                                this.selectedTemplate = this.templates[i]
                                break;
                            }
                        }
                    }
                } else if (v.type === 'task.template') {
                    this.selectedTemplate = this.templates.find(
                        i => i.id === v.id
                    )
                }
            }
        },
        templateChanged() {
            this.selectedTemplateOption = {}

            this.$emit('template-changed', this.selectedTemplate)

            this.updated()
        },
        optionChanged() {
            this.$emit('option-changed', this.selectedTemplateOption)

            this.updated()
        },
        updated() {
            if (this.optionsAreAvailable && this.selectedTemplateOption?.id) {
                this.$emit('input', {
                    ...this.selectedTemplateOption,
                    id: this.selectedTemplateOption.id,
                    type: 'task.template.option',
                })
            } else {
                this.$emit('input', {
                    ...this.selectedTemplate,
                    id: this.selectedTemplate.id,
                    type: 'task.template',
                })
            }
        },
        loadTemplates() {
            this.isLoading = true
            TaskResource.templates(TaskTemplateContexts.DEFECTS).then(response => {
                this.isLoading = false
                this.templates = response.data

                if (this.filterCallback) {
                    this.templates = this.templates.filter(template => {
                        return this.filterCallback(template)
                    });
                }

                this.updateInternalValues(this.value)
                this.$emit('loaded', { templates: this.templates });
            }, handleApiError);
        }
    },
    computed: {
        isSelectedTemplateOptionEmpty() {
            return isEmpty(this.selectedTemplateOption)
        },
        optionsAreAvailable() {
            return this.selectedTemplate &&
                this.selectedTemplate.options &&
                this.selectedTemplate.options.length > 0
        },
        availableOptions() {
            if (this.optionsAreAvailable) {
                return this.selectedTemplate.options
            }

            return []
        }
    }
}
</script>

<style scoped>

</style>